<template lang="pug">
  FullView(
    v-if='album'
    type='album'
    :id='album.id'
    :active='album.active'
    :cover='album.cover'
    :likes='album.likes'
    :artists='album.artists'
    :genres='album.genres'
    :editable='album.editable'
    :removable='album.editable'
    :running='running'
    :label='label'
    :title='album.name || $l10n("NO_NAME")'
    :year='album.year'
    :context-menu='contextMenu'
    @play='$emit("play")'
    @pause='$emit("pause")'
    @delete='$emit("delete")'
    @like='$emit("like")'
    @unlike='$emit("unlike")'
  )
</template>

<script>
import FullView from "@/components/FullView/FullView";

export default {
  inheritAttrs: false,
  name: "AlbumFullView",
  props: ["album", "running"],
  components: {
    FullView
  },
  computed: {
    label() {
      return (this.album.type === "album"
        ? this.$l10n("ALBUM")
        : this.$l10n("SINGLE")
      ).toLowerCase();
    },
    contextMenu() {
      return this.$contextMenu.create({
        addToQueue: {
          tracks: this.album.tracks,
          player: this.$player
        },
        addToPlaylist: {
          tracks: this.album.tracks,
          active: this.album.active
        },
        complain: {
          itemType: "album",
          itemId: this.album.id
        }
      });
    }
  }
};
</script>
